var _path, _path2, _path3, _path4, _path5, _g, _g2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarpetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Carpet_Icon",
    "data-name": "Carpet Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.925,
    height: 71.084,
    viewBox: "0 0 90.925 71.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M41.67,4.364,4.558,40.834s-7.718,13.229.789,21.417S49.79,66.5,49.79,66.5L89.7,26.632,64.206,25.461s6.165-11.782-2.677-20.2S41.67,4.364,41.67,4.364Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M28.092,61.587a15.416,15.416,0,1,1,0-21.807A15.414,15.414,0,0,1,28.092,61.587Z",
    transform: "translate(-0.678 0.353)",
    fill: "#b3001b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M23.875,57.36a9.753,9.753,0,1,1,0-13.793A9.762,9.762,0,0,1,23.875,57.36Z",
    transform: "translate(-0.463 0.568)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M40.233,55.6l-3.276,3.276a1.039,1.039,0,0,0,1.47,1.47L41.7,57.073a1.039,1.039,0,0,0-1.47-1.47ZM53.382,42.454,43.034,52.8a1.039,1.039,0,0,0,1.47,1.47L54.852,43.924a1.039,1.039,0,1,0-1.47-1.47ZM18.448,24.247,38.271,4.423a1.039,1.039,0,0,0-1.47-1.47L16.978,22.777a1.039,1.039,0,0,0,1.47,1.47ZM63.369,5.9a16.7,16.7,0,0,0-23.632,0L5.6,40.032A16.713,16.713,0,0,0,29.233,63.673c22.135-22.142,34.345-34.318,34.743-34.8A16.68,16.68,0,0,0,63.369,5.9ZM27.4,62.2A14.369,14.369,0,1,1,31.615,52.03,14.366,14.366,0,0,1,27.4,62.2Zm35.034-34.72-.073.085c-.236.283.538-.51-29.457,29.5A16.46,16.46,0,0,0,12.216,36.357l28.99-28.99A14.627,14.627,0,0,1,62.433,27.483Z",
    transform: "translate(-0.72 -0.998)",
    fill: "#02245a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M27.688,49.047a10.618,10.618,0,1,0,0,.014S27.689,49.052,27.688,49.047ZM10.857,56.665a8.714,8.714,0,1,1,14.775-7.34c-1.166,7.617-12.234,7.836-12.234.538a4.086,4.086,0,0,1,4.077-4.086,3.065,3.065,0,0,1,3.067,3.057,2.242,2.242,0,0,1-2.24,2.239A1.583,1.583,0,0,1,16.716,49.5a1.039,1.039,0,1,0-2.079,0A3.663,3.663,0,0,0,18.3,53.153a4.323,4.323,0,0,0,4.319-4.318A5.147,5.147,0,0,0,17.475,43.7a6.167,6.167,0,0,0-6.155,6.165c0,6.287,7.244,9.777,12.8,5.675a8.655,8.655,0,0,1-13.26,1.127Zm61.866,7.017a1.039,1.039,0,0,1-1.039-1.039V60.826a1.039,1.039,0,0,1,2.079,0v1.817A1.039,1.039,0,0,1,72.723,63.682Zm0,6.873a1.039,1.039,0,0,1-1.039-1.039V67.7a1.039,1.039,0,0,1,2.079,0v1.817A1.039,1.039,0,0,1,72.723,70.555Zm4.345-4.345H75.251a1.039,1.039,0,1,1,0-2.079h1.817a1.039,1.039,0,0,1,0,2.079Zm-6.873,0H68.378a1.039,1.039,0,1,1,0-2.079h1.817a1.039,1.039,0,1,1,0,2.079Z",
    transform: "translate(-0.502 0.529)",
    fill: "#02245a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(11.336 0.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M16.32,11.136h0a4.695,4.695,0,1,1,4.538-5.9A4.7,4.7,0,0,1,16.32,11.136Zm0-7.311A2.619,2.619,0,0,0,13.8,7.113c.9,3.375,5.939,1.99,5.053-1.344A2.617,2.617,0,0,0,16.324,3.825Z",
    transform: "translate(-11.626 -1.747)",
    fill: "#02245a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(5.106 12.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M8.749,19.015A3.118,3.118,0,1,1,11.766,15.1,3.121,3.121,0,0,1,8.749,19.015Zm-.265-4.122a1.036,1.036,0,0,0-.737,1.271,1.039,1.039,0,1,0,.737-1.271Z",
    transform: "translate(-5.632 -12.779)",
    fill: "#02245a"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 33.784,
    transform: "translate(15.54 66.554)",
    fill: "none",
    stroke: "#02245a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 25.676,
    transform: "translate(64.189 26.014)",
    fill: "none",
    stroke: "#02245a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y1: 40.541,
    x2: 40.541,
    transform: "translate(49.324 26.351)",
    fill: "none",
    stroke: "#02245a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpetIcon);
export default __webpack_public_path__ + "static/media/carpetIcon.cc243bd98b48c180185f45101500460e.svg";
export { ForwardRef as ReactComponent };